import { DeliveryAddressType } from '../DeliveryAddress/DeliveryAddress.js';
import type { DeliveryAddress } from '../../generated/api/models.js';
import type { AuthenticatedUser } from '../../public/site/authState';
import type { DeliveryAddressFormValues } from '../DeliveryAddressForm/DeliveryAddressForm.js';

export const getAddressFromFormValues = (
  type: DeliveryAddressType,
  formValues?: DeliveryAddressFormValues
): DeliveryAddress => {
  if (formValues) {
    return {
      address: {
        line1: formValues.addressLine1,
        line2: formValues.addressLine2,
        postalCode: formValues.postalCode,
        postOffice: formValues.postOffice,
        countryCode: formValues.countryCode,
      },
      companyName: type === DeliveryAddressType.COMPANY_ADDRESS ? formValues.companyName : '',
      recipient: formValues.recipientName,
      phoneNumber: formValues.phoneNumber,
    };
  }
  throw Error('Empty form values reference');
};

export const getFullNameFromAuthenticatedUser = (user?: AuthenticatedUser | null) =>
  user ? user.firstName + (user.lastName ? ' ' + user.lastName : '') : '';
